import { useToast } from "@/component/Toast/useToast";
import { threadStore } from "@/store/thread";
import { Input } from "antd";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

export const DEFAULT_THREAD_TITLE = "New Project";

export const ThreadTitle = observer(() => {
  const [isTitleEditing, setIsTitleEditing] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const thread = threadStore.thread;
  const threadTitle = threadStore.thread?.title;
  const threadId = threadStore.thread?.id;
  const isOwner = thread?.owner;
  const [title, setTitle] = useState(threadTitle);
  const { error: showErrorToast } = useToast();

  // 同步 store 中的 title
  useEffect(() => {
    if (!thread) {
      setTitle("");
      return;
    }

    if (!threadTitle) {
      setTitle(DEFAULT_THREAD_TITLE);
    }

    if (threadTitle && !isTitleEditing) {
      setTitle(threadTitle);
    }
  }, [thread, threadTitle, isTitleEditing]);

  const handleUpdateTitle = async () => {
    if (isUpdating) {
      return;
    }

    setIsUpdating(true);

    try {
      const trimmedTitle = title?.trim();
      if (!trimmedTitle) {
        showErrorToast("The title cannot be empty.");
        setTitle(threadTitle || DEFAULT_THREAD_TITLE);
      } else if (!threadId) {
        showErrorToast("Thread not found.");
      } else {
        await threadStore.updateThreadTitle(threadId, trimmedTitle);
      }
    } catch (error) {
      console.error(error);
      showErrorToast("Failed to update title.");
    } finally {
      setIsTitleEditing(false);
      setIsUpdating(false);
    }
  };

  const onTitleClick = () => {
    if (!isOwner) {
      return;
    }

    setIsTitleEditing(true);
  };

  if (isTitleEditing) {
    return (
      <Input
        variant="borderless"
        maxLength={100}
        autoFocus
        onChange={(e) => {
          setTitle(e.target.value);
        }}
        value={title}
        className="text-text-primary! text-base! p-0!"
        onPressEnter={handleUpdateTitle}
        onBlur={handleUpdateTitle}
      />
    );
  }

  return (
    <div
      className={classNames(
        "flex-1 text-text-primary text-base font-bold max-w-[180px] truncate",
        isOwner
          ? "cursor-pointer hover:underline hover:decoration-dotted hover:underline-offset-2"
          : ""
      )}
      onClick={onTitleClick}
      title={title}
    >
      {title}
    </div>
  );
});
